import React from 'react';

import { IconPropTypes } from 'ggApp/types/propTypes';

const Twitter = ({ color, size, className }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.30474 3.87305C6.56615 6.22769 8.14519 8.62748 11.0359 8.99412V8.48206C11.0359 6.00664 13.0426 3.99992 15.518 3.99992C17.0088 3.99992 18.3296 4.72774 19.1445 5.84744C19.5173 5.73884 19.6959 5.59328 19.7865 5.48317C19.9034 5.34124 19.9881 5.11989 19.9867 4.7421L21.9867 4.7347C21.9892 5.40619 21.8376 6.13862 21.3304 6.75453C20.9756 7.18538 20.5013 7.49319 19.9311 7.69424C19.9765 7.95001 20.0002 8.21327 20.0002 8.48206V9.99992C20.0002 16.6287 15.3007 20.9999 9.89301 20.9999C7.51652 20.9999 5.83776 20.2246 4.74421 19.4146C2.9678 18.0987 2.26627 16.2221 2.26627 16.2221C3.90551 16.3528 6.65706 16.3463 8.67851 14.7741L9.90639 16.3528C8.85593 17.1698 7.69771 17.8734 6.36984 18.0987C7.1596 18.575 8.30414 18.9999 9.89301 18.9999C14.1282 18.9999 18.0002 15.5933 18.0002 9.99992V8.48206C18.0002 7.11121 16.8889 5.99992 15.518 5.99992C14.1472 5.99992 13.0359 7.11121 13.0359 8.48206V10.8787C9.93365 11.4689 7.03262 10.066 5.0936 7.45762C4.7288 8.82515 5.62404 10.0921 6.71169 10.844L5.57433 12.4891C2.10309 10.0893 2.79804 5.8812 5.30474 3.87305Z"
            fill="#333333"
        />
        <path
            d="M6.80007 12.3096L7.97561 13.9276C6.17115 15.2386 3.77539 15.2444 2.25195 13.481L3.76541 12.1735C4.60943 13.1505 5.82624 13.0171 6.80007 12.3096Z"
            fill="#333333"
        />
    </svg>
);

Twitter.propTypes = {
    ...IconPropTypes,
};

Twitter.defaultProps = {
    color: 'none',
    size: '24px',
};

export default Twitter;
